// Több lap: a refresh-token a közös localStorage-ban van, így egy másik lap
// kijelentkezése / bejelentkezése itt `storage` eseményként látszik.
//  - törölték (kijelentkezés, lejárt munkamenet): itt is helyi kijelentkezés — pl. a
//    tervező automatikus piszkozat-mentése is leáll;
//  - másik felhasználó tokenjére cserélték: itt is kijelentkezés (a lap saját, régi
//    access tokenje a régi felhasználóé — azzal nem dolgozhat tovább);
//  - ugyanannak a felhasználónak az új tokenje (rotáció): nincs teendő.
//  - kijelentkezett lapon megjelenő token (bejelentkezés egy másik lapon): a lap
//    kijelentkezett marad, amíg újra nem töltik / nem navigálnak (szándékosan óvatos: a
//    párhuzamos refresh-ek rotációnál egymás tokenjét tennék tiltólistára).
import type { AppDispatch, RootState } from './store';
import { clearAuthThisTab } from './slices/authSlice';
import { jwtUserId } from '../utils/jwt';

const REFRESH_KEY = 'refresh_token';

interface StoreLike {
  dispatch: AppDispatch;
  getState: () => RootState;
}

/** Feliratkozik a `storage` eseményre; a visszaadott függvény leiratkoztat. */
export function installCrossTabLogout(store: StoreLike, target: Window = window): () => void {
  // Csak ezen a lapon (állapot + a lap access tokenje). A közös refresh-tokent NEM
  // töröljük: másik felhasználó belépésekor az az övé — törlése őt is kiléptetné.
  const logoutHere = () => store.dispatch(clearAuthThisTab());
  const onStorage = (event: StorageEvent) => {
    // Csak a localStorage számít (a sessionStorage laponkénti).
    if (event.storageArea !== target.localStorage) return;
    // key === null: localStorage.clear() egy másik lapon.
    if (event.key === null || (event.key === REFRESH_KEY && event.newValue === null)) {
      logoutHere();
      return;
    }
    if (event.key !== REFRESH_KEY || event.newValue === event.oldValue) return;
    const newUserId = jwtUserId(event.newValue);
    // Elsődlegesen a régi és az új token felhasználóját vetjük össze — így a rotáció akkor
    // is felismerhető, ha ezen a lapon a felhasználó még be sem töltődött.
    const oldUserId = jwtUserId(event.oldValue);
    const currentUserId = store.getState().auth.user?.id;
    const previousUserId = oldUserId ?? (currentUserId !== undefined ? String(currentUserId) : null);
    // Ugyanaz a felhasználó: rotáció, nincs teendő. Másik / olvashatatlan / nem eldönthető: kijelentkezés.
    if (newUserId === null || previousUserId === null || newUserId !== previousUserId) {
      logoutHere();
    }
  };
  target.addEventListener('storage', onStorage);
  return () => target.removeEventListener('storage', onStorage);
}
